<template>
  <v-dialog
    v-model="dialog"
    @click:outside="closeDialog"
    max-width="1000px"
    scrollable
    zIndex="210"
  >
    <v-card >
      <create-enquiry ref="createEnquiry" @created="updatedEnquiry"></create-enquiry>
      <edit-enquiry ref="editEnquiry" @edited="updatedEnquiry"></edit-enquiry>
      <completed-wizard ref="completedWizard"></completed-wizard>
      <v-toolbar dense :elevation="0">
        <v-toolbar-title class="text-primary-700">Manage Enquiries</v-toolbar-title>
        <!-- help icon that navigates to https://rp-database.com/docs/features/enquiries -->
          <a href="https://rp-database.com/docs/features/enquiries" class="mx-1" target="_blank">
            <v-icon>mdi-help-circle</v-icon>
          </a>
        <div class="flex-grow-1"></div>
        <v-btn style="width: 35px; height: 35px" icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="pt-4">
        <!-- scheme dropdown -->
         <div style="background-color: white; position:relative; z-index: 10;">
          <v-row v-if="!prefill" class="mb-0 py-2" align="center">
            
            <v-col cols="4">
              <v-btn-toggle v-model="typeToggle" 
                color="primary"
                mandatory
                small
                style="width:100%"
                variant="default"
                @update:modelValue="getEnquiries()"
                >
                <v-btn style="width:50%" height="56" :value="false">
                  Scheme
                </v-btn>
                <v-btn style="width:50%" height="56" :value="true">
                  Property
                </v-btn>
              </v-btn-toggle>
            </v-col>
            <v-col cols="8" v-if="!typeToggle">
              <v-combobox
                v-model="selectedScheme"
                :items="schemes"
                :item-title="item => item.label"
                :item-value="item => item.value"
                :item-text="'label'"
                outlined
                hide-details
                placeholder="Begin typing to search for a scheme"
                label="Scheme"
                :loading="schemeLoading"
                clearable
                :filter="(item, queryText) => {
                  return item
                }"
                ref="schemeCombobox"
                @update:search-input="searchScheme($event)"
              ></v-combobox>
            </v-col>
            <v-col cols="8" v-else>
              <v-combobox
                v-model="selectedProperties"
                :items="Properties"
                :item-title="item => item.label"
                :item-value="item => item.value"
                :item-text="'label'"
                :return-object="true"
                outlined
                hide-details
                placeholder="Begin typing to search for a property"
                label="Property"
                :loading="propertiesLoading"
                clearable
                :filter="(item, queryText) => {
                  return item
                }"
                ref="propertiesCombobox"
                @update:search-input="searchProperties($event)"
              ></v-combobox>
            </v-col>
          </v-row>
          <v-divider v-if="!prefill" class="mb-6"></v-divider>
          <v-row no-gutters>
              <v-checkbox
                v-model="hideWithdrawn"
                label="Hide Withdrawn/Completed"
                class="mt-1 float-right"
                hide-details
                @change="getEnquiries()"
              ></v-checkbox>
            <v-spacer></v-spacer>
            <v-col cols="7">
              <!-- checkbox toggle for hidewithdrawn -->
              <v-text-field
                v-model="search"
                append-icon="mdi-table-search"
                label="Search"
                outlined
                dense
                hide-details
                small
                class="ml-2"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="pt-2">
              <v-data-table
                
                style="border: 1px solid #e0e0e0; border-radius: 4px;"
                :headers="headers"
                :items="records"
                :search="search"
                :loading="loading"
                :multi-sort="false"
                :footer-props="{
                  'items-per-page-options': [10, 50, 100],
                }"
              >
                <template v-slot:body="{ items }">
                  <tbody v-if="items.length > 0">
                    <tr v-for="item in items" :key="item.id">
                      <td>{{ item.received_at }}</td>
                      <td>{{ item.created_at }}</td>
                      <td>{{ item.updated_at }}</td>
                      <td>{{ item.company.data.name }}</td>
                      <td style="text-transform: capitalize;">{{ item.stage }}</td>
                      <td style="text-transform: capitalize;">{{ item.reason }}</td>       
                      
                      <td class="">
                        <v-menu
                          v-if="item.unverified_history_count > 0"
                          max-width="200px"
                        >
                        </v-menu>
                        <v-icon
                          @click="editItem(item)"
                          small
                          class="mr-2"
                        >
                          mdi-pencil
                        </v-icon>
                        <v-icon
                          @click="deleteItem(item)"
                          small
                          class="mr-2"
                        >
                          mdi-delete
                        </v-icon>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr height="150">
                      <td class="text-center grey lighten-5"  :colspan="headers.length + 1">
                        <span class="grey--text" v-if="typeToggle && (selectedProperties == null || selectedProperties.value == null)">Select a property to view enquiries {{ selectedProperties }}</span>
                        <span class="grey--text" v-else-if="!typeToggle && (selectedScheme == null || selectedScheme.value == null)">Select a scheme to view enquiries</span>
                        <span class="grey--text" v-else>No records found</span>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
              <v-btn
                
                outlined
                color="primary"
                class="float-right mt-2 mb-0"
                :disabled="(typeToggle && (selectedProperties == null || selectedProperties.value == null)) || (!typeToggle && (selectedScheme == null || selectedScheme.value == null))"
                @click="createItem()"
              >
                Create new enquiry
              </v-btn>
            </v-col>
          </v-row>
        </div>
        
      </v-card-text>
    </v-card>
    
  </v-dialog>
</template>
<script>
  import createEnquiry from '@/components/enquiries/createEnquiry'; 
  import editEnquiry from '@/components/enquiries/editEnquiry';
  import completedWizard from '@/components/enquiries/completedWizard.vue';
  import CreateCompanyDialog from '@/components/companies/createCompanyDialog'
  import CreateUserDialog from '@/components/users/createUserDialog'
  import Comments from '@/components/common/comments'
import { create } from 'lodash';

  export default {
    components: {
      createEnquiry,
      editEnquiry,
      completedWizard,
      CreateCompanyDialog,
      CreateUserDialog,
      Comments,
    },
    data() {
      return {
        dialog: false,
        prefill: false,
        selectedScheme: null,
        selectedProperties: null,
        selectedCompany: null,
        selectedContact: null,
        typeToggle: false,
        schemes: [],
        Companies: [],
        Contacts: [],
        Properties: [],
        stage: '',
        stageOptions: [
          {value: 'interest', label: 'Interest'},
          {value: 'under_offer', label: 'Under Offer'},
          {value: 'completed', label: 'Completed'},
          {value: 'withdrawn', label: 'Withdrawn'},
        ],
        reason: null,
        reasonOptions: [
          {value: 'new_store', label: 'New Store'},
          {value: 'relocation', label: 'Relocation'},
          {value: 'upsize', label: 'Upsize'},
          {value: 'downsize', label: 'Downsize'},
          {value: null, label: 'Unknown'},
        ],

        hideWithdrawn: true,
        
        commentsContent: '',
        searchDialog: false,
        searchResults: [],
        searchInput: '',
        mentionedUsers: [],
        
        createNewComment: false,

        editedItem: {},
        editedComment: {},
        editingValue: '',
        editingLinks: [],
        editingComment: 0,

        editDialog: false,
        createDialog: false,
        taggingUser: false,
        search: '',
        pagination: {},
        totalRecords: 0,
        propertiesLoading: true,
        schemeLoading: true,
        companiesLoading: false,
        contactsLoading: true,
        loading: false,
        sortBy: 'id',
        sortDesc: true,
        itemsPerPage: 10,
        page: 1,

        loader: true,

        formErrors:{
          companyContact: false,
          stage: false,
          reason: false,
        },
        headers: [
          {text: 'Received On', value: 'received_at'},
          {text: 'Created On', value: 'created_at'},
          {text: 'Updated On', value: 'updated_at'},
          {text: 'Company', value: 'company.data.name'},
          {text: 'Stage', value: 'stage'},
          {text: 'Reason', value: 'reason'},
          {text: 'Actions', value: 'actions', sortable: false},
        ],
        records: [],

      };
    },
    props: ['propertyID', 'schemeID'],
    methods: {
      searchProperties(prop){
        clearTimeout(this._timerId)
        this._timerId = setTimeout(() => {
          this.page = 1
          this.propertiesLoading = true
          this.Properties = []
          this.getProperties(prop)
        }, 500)
      },

      searchScheme(prop){
        clearTimeout(this._timerId)
        this._timerId = setTimeout(() => {
          this.page = 1
          this.schemeLoading = true
          this.schemes = []
          this.getSchemes(prop)
        }, 500)
      },

      showDialog: function (propertyID = null, schemeID = null, label = null) {
        this.dialog = true;

        if(propertyID){
          this.typeToggle = true
          this.prefill = true
          this.$nextTick(() => {
            this.selectedProperties = {value: propertyID, label: label}
            this.getEnquiries()
          })
        }
        if(schemeID){
          this.typeToggle = false
          this.prefill = true
          this.$nextTick(() => {
            this.selectedScheme = {value: schemeID, label: label}
            this.getEnquiries()
          })
        }
       
      },
      
      closeDialog: function () {
        this.dialog = false;
      },

      getProperties(prop){
        // gets properties for dropdown
        this.$http.get("/properties",{
          params: {
            q: prop,
            //filter by scheme if there is a selected scheme
            //scheme_id: this.selectedScheme.value ? this.selectedScheme.value : undefined,
            per_page: 50,
            include: 'address,landlords,landlord_agents,tenant,scheme,tenant_agent_contacts,tenant_agents',
          }
        }).then(response => {
          // combine the address and tenant into a single string
          this.Properties = response.data.data.map(property => {
            return {
              value: property.id,
              label: `${property.address.data.full_address} - ${property.tenant.data.name}`
            }
          })
          this.propertiesLoading = false
        }).catch(error => {
          this.propertiesLoading = false
        })
      },

      async getSchemes(prop){
      // gets schemes for dropdown
        this.$http.get("/schemes",{
          params: {
            q: prop,
            include: 'address',
            type: 'all',
            per_page: 50,
          }
        }).then(response => {
          if(prop != ''){
            // this.schemes = response.data.data.map(scheme => {
            //   return scheme.name
            // })
            this.schemes = response.data.data.map(scheme => {
              return {
                value: scheme.id,
                label: `${scheme.name} - ${scheme.address.data.full_address}`
              }
            })
          }else{
            this.schemes = []
          }
          
          this.schemeLoading = false
        }).catch(error => {
          this.schemeLoading = false
        })
      },

      async getEnquiries(created){
        if(!(this.typeToggle && (this.selectedProperties == null || this.selectedProperties.value == null) || !this.typeToggle && (this.selectedScheme == null || this.selectedScheme.value == null))){
          this.loading = true
          this.$http.get("/enquiries?include=company,user,scheme,property,comments,size,rent,size_from",{
            params: {
              property_id: this.typeToggle ? this.selectedProperties.value : null,
              scheme_id: !this.typeToggle ? this.selectedScheme.value : null,
              stage: this.hideWithdrawn ? ['interest', 'under_offer'] : null,
              // company_id: this.selectedCompany.value ? this.selectedCompany.value : undefined,
              // user_id: this.selectedScheme.value ? this.selectedScheme.value : undefined,
              // stage: this.stage,
              // reason: this.reason,
            }
          }).then(response => {
            this.records = response.data.data
            this.totalRecords = response.data.meta.pagination.total
            this.records.forEach(record => {
              record.reason = record.reason.replace(/_/g, ' ')
              record.stage = record.stage.replace(/_/g, ' ')
            })
            this.loading = false

            if(created){
              this.editItem(this.records[this.records.length - 1])
            }
          }).catch(error => {
            this.loading = false
          })
        }else{
          this.records = []
        }
      },

      createItem(){
        this.$refs.createEnquiry.openDialog(this.typeToggle ? {id: this.selectedProperties.value, label: this.selectedProperties.label, type: 'property'} : {id: this.selectedScheme.value, label: this.selectedScheme.label, type:'scheme'})
      },

      editItem(item){
        this.$refs.editEnquiry.openDialog(item)
      },

      validateForm(){
        let errors = false
        if(this.selectedCompany == null && this.selectedContact == null){
          this.formErrors.companyContact = true
          errors = true
        }
        if(this.stage == '' || this.stage == null){
          this.formErrors.stage = true
          errors = true
        }
        return !errors
      },

      deleteItem(item){
        this.$notify.question(`Are you sure you want to delete this enquiry?`, () => {
          this.$http.delete(`/enquiries/${item.id}`).then(response => {
            this.getEnquiries()
            this.createDialog = false
            this.editDialog = false
          }).catch(error => {
          })
        })
      },

      updatedEnquiry(entity){
        this.getEnquiries()

        // if entity has stage completed, notify the user if they wish to create a new deal
        if(entity.stage == 'completed'){
          this.$notify.question(`An enquiry has been completed, Would you like to create a new deal for this enquiry?`, () => {
            this.$refs.completedWizard.openDialog(entity, this.selectedProperties, this.selectedScheme)
          })
        }

        this.$emit('updated')
      }

    },


    watch: {
      pagination: {
        handler() {
          this.getEnquiries()
        },
        deep: true
      },

      // watch for changes in the selected scheme, if there is a change, get the properties and the enquiries
      selectedScheme() {
        this.getEnquiries()
      },

      // watch for changes in the selected properties, if there is a change, get the enquiries
      selectedProperties() {
        this.getEnquiries()
      },

      // watch for changes in typeToggle, if there is a change, get the enquiries and reset selected properties and schemes
      typeToggle() {
        this.selectedProperties = null;
        this.selectedScheme = null;
      },

      page() {
        this.$vuetify.goTo(1)
      },

      // show dialog function
      openDialog: function () {
        // this.dialog = true;
        // if(this.propertyID){
        //   this.selectedProperties = {value: this.propertyID, label: this.propertyID}
        //   this.typeToggle = true
        //   this.getEnquiries()
        // }
        // if(this.schemeID){
        //   this.selectedScheme = {value: this.schemeID, label: this.schemeID}
        //   this.typeToggle = false
        //   this.getEnquiries()
        // }
      },


    },

    computed: {
      // copy the content of the comments element
      // commentsContent(){
      //   let comments = document.getElementById('commentInput')
      //   if(comments){
      //     console.log(comments.innerHTML)
      //     return comments.innerHTML
      //   }else{
      //     console.log('no comments')
      //     return 'no comments'
      //   }
      // }
    },

    

    mounted() {
      this.getProperties()
      this.getSchemes()
    }
  };
</script>
<style>
/* slide transition */
/* .slide-enter-active, .slide-leave-active {
  transition: transform 0.3s;
}
.slide-enter, .slide-leave-to {
  transform: translateY(-100%);
} */




</style>